import { render, staticRenderFns } from "./AlertsListComponent.vue?vue&type=template&id=b86f7f80&scoped=true&"
import script from "./AlertsListComponent.vue?vue&type=script&lang=js&"
export * from "./AlertsListComponent.vue?vue&type=script&lang=js&"
import style0 from "./AlertsListComponent.vue?vue&type=style&index=0&id=b86f7f80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86f7f80",
  null
  
)

export default component.exports